module.exports = __webpack_public_path__ + "static/img/7f5a8d7d7597ed9df6ada8f1eee25122.fe235de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7f5a8d7d7597ed9df6ada8f1eee25122.jpg
// module id = 2re2
// module chunks = 1